import { UserOutlined } from '@ant-design/icons';
import { Avatar as AntAvatar } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { BaseInfoContext } from '@/context/BaseInfoContext';
import { AvatarProps } from 'antd/es/avatar';

type Props = Partial<
  {
    path: string;
  } & AvatarProps
>;

const Avatar: React.FC<Props> = ({ path, ...avatarProps }: Props) => {
  const [baseInfo] = useContext(BaseInfoContext);
  if (path) {
    return <AntAvatar src={`${baseInfo.assetsPrefix}${path}`} {...avatarProps} />;
  } else {
    return <AntAvatar icon={<UserOutlined />} {...avatarProps} />;
  }
};

export default Avatar;

export const ReloadableAvatar = ({
  srcStrategy,
  retry = 5,
  ...avatarProps
}: AvatarProps & {
  srcStrategy?: (src: string, retry: number) => Promise<string>;
  /**重试次数 */
  retry?: number;
  src: string;
}) => {
  const [retryTimes, setRetryTimes] = useState(1);
  const [src, updateSrc] = useState(avatarProps.src);

  useEffect(() => {
    updateSrc(avatarProps.src);
    setRetryTimes(1);
  }, [avatarProps.src]);

  return (
    <Avatar
      {...avatarProps}
      src={src}
      onError={() => {
        if (retryTimes <= retry) {
          try {
            if (srcStrategy) {
              // src 替换策略
              srcStrategy(src, retryTimes).then(newSrc => {
                updateSrc(newSrc);
              });
            }

            setRetryTimes(retryTimes + 1);
          } catch (e) {}
        }
        return false;
      }}
    />
  );
};
